var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._t("default"),_vm._v(" "),_c('img',{staticClass:"icon",attrs:{"src":require("dashboard/assets/icons/ic_close.svg"),"alt":""},on:{"click":_vm.onClick}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }